<template>
  <div class="padding-10">
    <div class="text-center mb-6">
        <h1 class="main-title font-weight-bold mb-2">
          TECHNICIAN QUICK LOOK-UP
        </h1>
        <p class="main-subtitle text--darken-1">
          KEY MADE AUTOMOBILE
        </p>
    </div>
    <v-btn tile color="info" style="margin-bottom: 10px;" @click="clearForm">
      <v-icon left>mdi-refresh</v-icon>
      <slot>Clear Form</slot>
    </v-btn>
    <v-card class="white-background padding-5">
      <v-form v-if="!isLoading" v-model="isValid" ref="form">
        <Form
          :item="item"
          :toolbar="toolbar"
          :template="template"
          v-model="form"
          ref="lookupForm"
        ></Form>
      </v-form>
      <div v-else class="d-flex justify-center align-center" style="height: 300px">
      </div>
    </v-card>
  </div>
</template>

<script>
import Form from "../components/customers/create/Form.vue";

export default {
  components: { Form },
  data() {
    return {
      isLoading: true,
      isValid: false,
      item: {
        fields: {}
      },
      form: {},
      toolbar: {
        template: "",
      },
      template: {},
    };
  },
  methods: {
    clearForm() {
      // if (this.$refs.form) {
      //   this.$refs.form.reset();
      // }
      if (this.$refs.lookupForm) {
        this.$refs.lookupForm.init();
      }
    },
  },
  beforeDestroy() {
    this.$store.dispatch("fetchVisibleFields", []);
  },
  created() {
    this.$loader.show();
  },
  async mounted() {
    this.$loader.show();
    try {
      // const lookupFormData = await this.$store.dispatch("fetchTemplateByName", "lookup form");
      // const data = await this.$store.dispatch("fetchTemplateByName", "50-AUTOMOTIVE - LOST KEYS / PROGRAMMING / DUPLICATION");
      const [
        lookupFormData,
        data
      ] = await Promise.all([
        this.$store.dispatch("fetchTemplateByName", "lookup form"),
        this.$store.dispatch("fetchTemplateByName", "50-AUTOMOTIVE - LOST KEYS / PROGRAMMING / DUPLICATION"),
        this.$store.dispatch("fetchQuickLookUpFields")
      ])

      if (data) {
        this.template = data;
        this.toolbar.template = data.id;
      } 

      this.$store.dispatch("fetchVisibleFields", lookupFormData.fields || [])
      } catch (error) {
        console.error("form error:", error);
      } finally {
        this.isLoading = false;
        this.$loader.hide();
      }
  }
};
</script>

<style scoped>
.main-title {
  font-size: 36px;
  letter-spacing: 1px;
}

.main-subtitle {
  font-size: 24px;
  font-weight: bolder;
  margin: 0 auto;
}

@media (max-width: 600px) {
  .main-title {
    font-size: 20px;
  }
  .main-subtitle {
    font-size: 18px;
  }
}
</style>